import { render, staticRenderFns } from "./HomeMessagesCard.vue?vue&type=template&id=11c1398c&"
import script from "./HomeMessagesCard.vue?vue&type=script&lang=js&"
export * from "./HomeMessagesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports